import { type FC } from "react";

export const SwitchCustom: FC<{
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}> = ({ value, onChange, disabled = false }) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={() => onChange(!value)}
      className={`
        relative w-10 h-[20px] flex items-center rounded-full p-1 transition-colors
        ${value ? "bg-green-500" : "bg-gray-300"}
      `}
    >
      <span
        className={`
          w-3.5 h-3.5 bg-white rounded-full shadow-md transform transition-transform
          ${value ? "translate-x-[19px]" : "translate-x-[-2px]"}
        `}
      />
    </button>
  );
};
